import {
  As,
  Button,
  ButtonProps,
  HStack,
  Icon,
  Text,
  IconProps,
  Box,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
interface NavButtonProps extends ButtonProps {
  icon: As;
  label: string;
  isSelected?: boolean;
}

export const NavButton = (
  props: NavButtonProps & { iconProps?: IconProps; route: string }
) => {
  const { icon, label, iconProps, isSelected, route, ...buttonProps } = props;
  return (
    <Link to={route} style={{ textDecoration: "none" }}>
      <Button
        position="relative"
        variant="ghost"
        width="100%"
        justifyContent="start"
        _hover={buttonProps.bg ? { bg: buttonProps.bg } : undefined}
        {...buttonProps}
      >
        <HStack spacing="3">
          <Icon as={icon} boxSize="6" color="subtle" {...iconProps} />
          <Text>{label}</Text>
        </HStack>
        {isSelected && (
          <Box
            position="absolute"
            left="-24px"
            right="0"
            bottom="0"
            top="2px"
            width="4.5px"
            height="100%"
            bg="black"
            borderRightRadius="4px"
          />
        )}
      </Button>
    </Link>
  );
};
